import { client } from "@/http/client"

import { IPagingResponse, IRequestParams } from "@/types/api"
import { ITransportModel } from "@/types/ITransportModel"

export const getTransportModels = (params: IRequestParams): Promise<IPagingResponse<ITransportModel>> =>
    client.get("/TransportModels", {
        params
    })
